export default "/images/policy_sm.jpg?05d9b7c9b9307972f53162f0d8a222ec";